import { isArrayLike } from '@kurtosys/ksys-app-template/dist/utils/isArrayLike';
import { isNullOrEmpty } from '@kurtosys/ksys-app-template/dist/utils/typeChecks';
import { sortValues } from './';
import { DataSort } from '../models/configuration/DataSort';

export default function getDocumentGroupOrder(
    groupedDocuments: any,
    propertySort: DataSort,
    target: 'meta' | 'inferred' = 'meta'
) {
    const orderValues = [];
    for (const documentGroupName of Object.keys(groupedDocuments)) {
        if (target === 'meta') {
            const groupedDocument = groupedDocuments[documentGroupName].find(
                document => {
                    return document.meta && document.meta[propertySort.key];
                }
            );
            if (groupedDocument) {
                const orderMetaProperty =
                    groupedDocument.meta[propertySort.key];
                if (orderMetaProperty) {
                    orderValues.push({
                        [propertySort.key]: isArrayLike(orderMetaProperty.value)
                            ? orderMetaProperty.value[0]
                            : orderMetaProperty.value,
                        groupName: documentGroupName,
                    });
                }
            }
        }
        if (target === 'inferred') {
            const groupedDocument = groupedDocuments[documentGroupName].find(
                document => {
                    return (
                        document.inferred && document.inferred[propertySort.key]
                    );
                }
            );
            if (groupedDocument) {
                const value = groupedDocument.inferred[propertySort.key];
                if (value) {
                    orderValues.push({
                        [propertySort.key]: isArrayLike(value)
                            ? value[0]
                            : value,
                        groupName: documentGroupName,
                    });
                }
            }
        }
    }

    if (!isNullOrEmpty(orderValues)) {
        const sorted = sortValues(orderValues, propertySort);
        return sorted.map(sort => sort.groupName);
    }

    return [];
}



// WEBPACK FOOTER //
// ./src/utils/getDocumentGroupOrder.ts